import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressLookupService } from './address-lookup.service';
import { ImageManipulationService } from './image-manipulation.service';
import { OcrService } from './ocr.service';
import { SignaturePadModule } from 'angular2-signaturepad';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorComponent } from './form-error/form-error.component';
import { PostcodeQuestionComponent } from './question-components/postcode-question.component';
import { TextboxQuestionComponent } from './question-components/textbox-question.component';
import { SignaturePadComponent } from './signature-pad.component';
import { SignatureQuestionComponent } from './question-components/signature-question.component';
import { DropdownQuestionComponent } from './question-components/dropdown-question.component';
import { ToggleQuestionComponent } from './question-components/toggle-question.component';
import { GeneralQuestionComponent } from './question-components/general-question.component';
import { ImageUploadQuestionComponent } from './question-components/image-upload-question.component';
import { ButtonGroupQuestionComponent } from './question-components/button-group-question.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageAssetFactory } from '../domain/card';
import { NgxSpinnerModule } from 'ngx-spinner';
import { QuestionHintComponent } from './question-hint.component';
import { OcrImageUploadQuestionComponent } from './question-components/ocr-image-upload-question.component';
import { ScrollService } from './scroll.service';
import { AddressListDropdownQuestionComponent } from './question-components/address-list-dropdown-question.component';
import { GoogleMapsMarkerQuestionComponent } from './question-components/google-maps-marker-question.component';
import { AgmCoreModule } from '@agm/core';
import { W3wService } from './w3w.service';
import { MultiImageUploadQuestionComponent } from './question-components/multi-image-upload-question.component';
import { TextareaQuestionComponent } from './question-components/textarea-question.component';
import { GetAddressIoAddressToAddressTransformer } from '../transformers/get-address-io-address-to-address.transformer';
import { MultiDropdownWithValueQuestionComponent } from './question-components/multi-dropdown-with-value-question.component';
import { FreeformAddressQuestionComponent } from './question-components/freeform-address-question.component';
import { GooglePlacesComponent } from './question-components/google-places.component';
import { GoogleAddressToAddressTransformer } from '../transformers/google-address-to-address.transformer';
import { ImageAssetComponent } from './image-asset.component';
import { DocumentViewerQuestionComponent } from './question-components/document-viewer-question.component';
import { DocumentViewerModalComponent } from './modals/document-viewer-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SignaturePadModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxSpinnerModule,
    AgmCoreModule
  ],
  declarations: [
    GeneralQuestionComponent,
    ImageUploadQuestionComponent,
    MultiImageUploadQuestionComponent,
    OcrImageUploadQuestionComponent,
    PostcodeQuestionComponent,
    DropdownQuestionComponent,
    AddressListDropdownQuestionComponent,
    FreeformAddressQuestionComponent,
    GooglePlacesComponent,
    ImageAssetComponent,
    SignatureQuestionComponent,
    TextboxQuestionComponent,
    TextareaQuestionComponent,
    ToggleQuestionComponent,
    FormErrorComponent,
    SignaturePadComponent,
    ButtonGroupQuestionComponent,
    QuestionHintComponent,
    GoogleMapsMarkerQuestionComponent,
    MultiDropdownWithValueQuestionComponent,
    DocumentViewerQuestionComponent,
    DocumentViewerModalComponent
  ],
  entryComponents: [DocumentViewerModalComponent],
  providers: [
    AddressLookupService,
    W3wService,
    ImageManipulationService,
    OcrService,
    ScrollService,
    GetAddressIoAddressToAddressTransformer,
    GoogleAddressToAddressTransformer,
    ImageAssetFactory
  ],
  exports: [
    GeneralQuestionComponent,
    ImageUploadQuestionComponent,
    MultiImageUploadQuestionComponent,
    OcrImageUploadQuestionComponent,
    PostcodeQuestionComponent,
    DropdownQuestionComponent,
    AddressListDropdownQuestionComponent,
    FreeformAddressQuestionComponent,
    GooglePlacesComponent,
    ImageAssetComponent,
    SignatureQuestionComponent,
    TextboxQuestionComponent,
    TextareaQuestionComponent,
    ToggleQuestionComponent,
    FormErrorComponent,
    SignaturePadComponent,
    ButtonGroupQuestionComponent,
    QuestionHintComponent,
    GoogleMapsMarkerQuestionComponent,
    MultiDropdownWithValueQuestionComponent,
    DocumentViewerQuestionComponent
  ]
})
export class CoreModule {}
